import React from 'react';

/** Values acceptable to the `Intl` DateTime formatter. */
export type DateFormattable = Date | number;

export interface DateTextProps {
  /**
   * The date to be formatted as a Date object or a `number` that is an acceptable time
   * value for the `Date` constructor.
   */
  date: DateFormattable;
  format?:
    | 'short-weekday'
    | 'full-numeric'
    | 'short'
    | 'full-numeric-with-time'
    | 'short-with-time';
  /**
   * The component to render the formatted date into. Defaults to a `Text`. For typical
   * usage this is probably fine.
   */
  renderHost?: React.FC;
}

const formatters = {
  short: new Intl.DateTimeFormat('default', { month: 'short', day: 'numeric' }),
  'short-weekday': new Intl.DateTimeFormat('default', {
    month: 'short',
    weekday: 'short',
    day: 'numeric',
  }),
  'full-numeric': new Intl.DateTimeFormat('default', {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
  }),
  'full-numeric-with-time': new Intl.DateTimeFormat('default', {
    month: '2-digit',
    day: '2-digit',
    year: '2-digit',
    hour: 'numeric',
    minute: 'numeric',
  }),
  'short-with-time': new Intl.DateTimeFormat('default', {
    month: 'short',
    day: '2-digit',
    hour: 'numeric',
    minute: 'numeric',
  }),
};

export const DateText = ({ date, format = 'short-weekday' }: DateTextProps) => (
  <span>{formatters[format].format(date)}</span>
);
